module.exports = __webpack_public_path__ + "img/_2.6dda08d3.png";